import { useEffect, useState } from "react";
import { getApi } from "../utils/api.ts";
import Cookies from "js-cookie";
import { API_GET_CELEBRATIONS_DATA } from "../../config/Endpoints";

export interface CelebrationApiItem {
  id: number;
  name: string;
  birthdayDate: string | null;
  anniversaryDate: string | null;
  type: "BIRTHDAY" | "ANNIVERSARY";
  yearsCompleted: number | null;
  photoPath: string | null;
}

export type CelebrationBucket = "today" | "upcoming";

export type CelebrationItem = CelebrationApiItem & {
  bucket: CelebrationBucket;
};

type CelebrationsPayload = {
  todays?: CelebrationApiItem[];
  upcoming?: CelebrationApiItem[];
};

function normalizeCelebrationsPayload(
  raw: unknown,
): CelebrationItem[] {
  if (!raw || typeof raw !== "object") return [];

  if (Array.isArray(raw)) {
    return (raw as CelebrationApiItem[]).map((item) => ({
      ...item,
      bucket: "today" as const,
    }));
  }

  const { todays = [], upcoming = [] } = raw as CelebrationsPayload;
  const todayList = Array.isArray(todays) ? todays : [];
  const upcomingList = Array.isArray(upcoming) ? upcoming : [];

  return [
    ...todayList.map((item) => ({ ...item, bucket: "today" as const })),
    ...upcomingList.map((item) => ({ ...item, bucket: "upcoming" as const })),
  ];
}

export function useCelebrations() {
  const [data, setData] = useState<CelebrationItem[]>([]);
  const [loading, setLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");

  useEffect(() => {
    async function fetchCelebrations() {
      try {
        setLoading(true);
        const res = await getApi<{ data: unknown }>(
          API_GET_CELEBRATIONS_DATA,
          accessToken,
        );
        setData(normalizeCelebrationsPayload(res?.data?.data));
      } catch (err) {
        console.error(err);
        setData([]);
      } finally {
        setLoading(false);
      }
    }

    fetchCelebrations();
  }, [accessToken]);

  return { data, loading };
}
